import { endpoints } from '@/config/api';
import { apiClient } from '@/lib/apiClient';
import type { CreateSavedAddressDTO, SavedAddress, UpdateAddressPurposeDTO } from '@/types';

export const savedAddressService = {
  async getSavedAddresses(): Promise<SavedAddress[]> {
    return apiClient.get<SavedAddress[]>(endpoints.savedAddresses.list);
  },

  async createSavedAddress(data: CreateSavedAddressDTO): Promise<SavedAddress> {
    return apiClient.post<SavedAddress>(endpoints.savedAddresses.create, data);
  },

  async setDefaultSavedAddress(id: string): Promise<SavedAddress> {
    return apiClient.patch<SavedAddress>(endpoints.savedAddresses.setDefault(id), {});
  },

  async updateAddressPurpose(id: string, purpose: string | null): Promise<SavedAddress> {
    const data: UpdateAddressPurposeDTO = { purpose };
    return apiClient.patch<SavedAddress>(endpoints.savedAddresses.updatePurpose(id), data);
  },

  async deleteSavedAddress(id: string): Promise<void> {
    return apiClient.delete(endpoints.savedAddresses.delete(id));
  },
};
